var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.21 180.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#16e0bd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.11,72.17c0,33.13-39.29,60.25-89,62.41a6.73,6.73,0,0,0-6.43,6.73v42.33A6.74,6.74,0,0,1,65,190.38H55.8V112.26H69c31.15,0,57.87-13.42,67-32.77a7.38,7.38,0,1,0-6.61-2.44C121.14,93.49,96.69,105.26,69,105.26H55.8v-38a7.37,7.37,0,1,0-7,0V190.38H39.64a6.75,6.75,0,0,1-6.75-6.74V42.45h68.62a7.37,7.37,0,1,0,0-7H32.89V16.36a6.75,6.75,0,0,1,6.75-6.74H71.7C124.39,9.62,167.11,37.62,167.11,72.17Z",
    transform: "translate(-32.89 -9.62)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.41d68617814bf385db68eb0b31162a98.svg";
export { ForwardRef as ReactComponent };